import { Grid, TextField } from "../../../../components";

const FormFiltroAvancado = ({ valueInput, onChangeInput }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="nome"
          name="nome"
          label="Nome"
          fullWidth
          variant="outlined"
          onChange={(event) => onChangeInput(event)}
          value={valueInput("nome")}
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
